import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { PDFFile } from '../../../../interfaces/interfaces';
import Link from 'next/link';

const PDFMaterial = ({ pdf }: { pdf: PDFFile }) => {
  const { t } = useTranslation(['common']);
  const apiURL = process.env.baseURL + process.env.basePath!;
  // const baseApi = http://localhost:8080/api/v1//file/display/5fa72ee1b6822306cc6d678a
  return (
    <div className="flex items-center">
      <FontAwesomeIcon size="2x" icon={faFilePdf} />
      <p className="w-1/2 ml-4 mr-4 break-words grow">{pdf.name}</p>
      <Link href={`${apiURL}file/display/${pdf.file}`} target="_blank" className="px-4 py-1 text-xs rounded bg-buttons-main templateBorder">
        {t('common:open')}
      </Link>
    </div>
  );
};

export default PDFMaterial;
